import { render, staticRenderFns } from "./HomeEventosFerramentas.vue?vue&type=template&id=5a12d2f8&"
import script from "./HomeEventosFerramentas.vue?vue&type=script&lang=js&"
export * from "./HomeEventosFerramentas.vue?vue&type=script&lang=js&"
import style0 from "./HomeEventosFerramentas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports